/* ============================================================================
   NFP — Save X% badge
   ----------------------------------------------------------------------------
   Self-contained script that injects a "Save 16%" (or whatever the actual
   percentage works out to) badge next to product prices on:
     • Product detail pages (sections/main-product.liquid output)
     • Product cards in collection/search/featured grids (snippets/product-block.liquid output)

   Reads the prices that the theme already rendered into the DOM. No theme
   Liquid edits required. Computes savings client-side and stays in sync
   with variant switching via MutationObserver on the existing price spans.

   Assumes existing CSS class .product-price__savings is defined in
   styles-nfp-global.css.
   ============================================================================ */
(function () {
  'use strict';

  function parsePrice(str) {
    if (!str) return NaN;
    var cleaned = String(str).replace(/[^\d.,]/g, '').replace(/,/g, '');
    return parseFloat(cleaned);
  }

  function computePct(sale, compare) {
    if (!sale || !compare || compare <= sale) return 0;
    return Math.round(((compare - sale) * 100) / compare);
  }

  function makeBadge() {
    var badge = document.createElement('span');
    badge.setAttribute('data-nfp-savings-badge', '');
    badge.className = 'product-price__savings hide';
    return badge;
  }

  /* ------------------------------------------------------------------------
     Product detail page (any element with [data-price-wrapper])
     ------------------------------------------------------------------------ */
  function refreshDetailBadge(wrapper) {
    var priceEl = wrapper.querySelector('[data-product-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    if (!priceEl) return;

    var sale = parsePrice(priceEl.textContent);
    var compare = compareEl ? parsePrice(compareEl.textContent) : 0;
    var pct = computePct(sale, compare);

    var badge = wrapper.querySelector('[data-nfp-savings-badge]');
    if (!badge) {
      badge = makeBadge();
      // Insert after the compare-price element so the badge sits inline
      // with the prices, before any unit-price block that follows.
      if (compareEl && compareEl.parentNode === wrapper) {
        wrapper.insertBefore(badge, compareEl.nextSibling);
      } else {
        wrapper.appendChild(badge);
      }
    }

    if (pct > 0) {
      badge.textContent = 'Save ' + pct + '%';
      badge.classList.remove('hide');
    } else {
      badge.classList.add('hide');
    }
  }

  function watchDetailWrapper(wrapper) {
    refreshDetailBadge(wrapper);

    var priceEl = wrapper.querySelector('[data-product-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');

    var observer = new MutationObserver(function () {
      refreshDetailBadge(wrapper);
    });

    if (priceEl) {
      observer.observe(priceEl, { childList: true, subtree: true, characterData: true });
    }
    if (compareEl) {
      observer.observe(compareEl, { childList: true, subtree: true, characterData: true });
    }
  }

  /* ------------------------------------------------------------------------
     Product cards (.product-block) — repurpose the existing
     .product-label--on-sale span by swapping its text from "Sale" to "Save X%"
     ------------------------------------------------------------------------ */
  function refreshCardBadge(card) {
    var saleLabel = card.querySelector('.product-label--on-sale');
    if (!saleLabel) return;

    var reduced = card.querySelector('.product-price__reduced');
    var compare = card.querySelector('.product-price__compare');
    if (!reduced || !compare) return;

    var sale = parsePrice(reduced.textContent);
    var cmp = parsePrice(compare.textContent);
    var pct = computePct(sale, cmp);

    if (pct > 0) {
      saleLabel.textContent = 'Save ' + pct + '%';
    }
  }

  /* ------------------------------------------------------------------------
     Init
     ------------------------------------------------------------------------ */
  function init() {
    var wrappers = document.querySelectorAll('[data-price-wrapper]');
    Array.prototype.forEach.call(wrappers, watchDetailWrapper);

    var cards = document.querySelectorAll('.product-block');
    Array.prototype.forEach.call(cards, refreshCardBadge);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================================
   NFP — Seal Subscriptions customizations (v3)
   ----------------------------------------------------------------------------
   Self-contained, no theme.liquid edits required. On product pages where the
   Seal Subscriptions widget is auto-injected, this module:
     • injects brand-matching CSS (rounded box, green selected state,
       pill SAVE% badge, light "Subscription details" popup)
     • moves the widget to sit just above the Add-to-Cart row so the two
       read as one module
     • rewrites Seal's off-site "how subscriptions work" links to our own
       on-site page (/pages/how-subscriptions-work)
   No-ops on any page without the widget.
   ============================================================================ */
(function () {
  'use strict';

  var PAGE = '/pages/how-subscriptions-work';

  var CSS = [
    '.sealsubs-target-element{margin:0!important}',
    '.sealsubs-container{border:1px solid #cccccc!important;border-radius:16px!important;background:#fff!important;padding:12px 14px!important;box-shadow:none!important}',
    '.sls-purchase-options-label{font-weight:700!important;color:#1f2933!important;font-size:1rem!important;display:block!important;margin:0 0 8px!important}',
    /* inner options box: rounded, clipped; rows divided by a hairline, no per-row fill/outline */
    '.sls-purchase-options-container{border:1px solid rgba(0,0,0,0.12)!important;border-radius:12px!important;overflow:hidden!important;background:#fff!important}',
    '.sls-purchase-options-container .seal-row{border:0!important;border-radius:0!important;padding:8px 14px!important;margin:0!important;background:transparent!important;box-shadow:none!important}',
    '.sls-purchase-options-container .seal-row + .seal-row{border-top:1px solid rgba(0,0,0,0.10)!important}',
    /* selected state = radio only (no background, no outline) */
    '.sls-custom-radio{border-color:#9aa6ad!important}',
    '.seal-row:has(input.sls-option:checked) .sls-custom-radio{border-color:#87af59!important;background:#87af59!important}',
    '.sls-savings-badge{background:#87af59!important;color:#fff!important;border:0!important;border-radius:999px!important;padding:3px 10px!important;font-weight:700!important;font-size:.72rem!important;letter-spacing:.02em!important;line-height:1!important;display:inline-block!important;box-shadow:none!important;clip-path:none!important;-webkit-clip-path:none!important}',
    '.sls-savings-badge::before,.sls-savings-badge::after{display:none!important}',
    'select.sls-select,.sls-purchase-options-container select.sls-select{-webkit-appearance:auto!important;appearance:auto!important;background-image:none!important;background-color:#fff!important;border:1px solid #cccccc!important;border-radius:10px!important;padding:6px 10px!important;height:auto!important;color:#1f2933!important;font-size:.95rem!important}',
    '.sls-subscription-details-label{color:#5b7f3a!important;cursor:pointer}',
    /* popup: single white card, light-green border, keep the little arrow */
    '.sls-more-info-popup{background:#fff!important;border:1px solid #87af59!important;border-radius:12px!important;box-shadow:0 14px 34px rgba(0,0,0,0.14)!important;color:#1f2933!important;margin-left:-8px!important}',
    '.sls-more-info-popup-content{background:transparent!important;color:#1f2933!important;border:0!important;border-radius:0!important;box-shadow:none!important;padding:0!important;font-size:.9rem!important;line-height:1.45!important}',
    '.sls-more-info-popup-content br{display:none!important}',
    '.sls-more-info-popup-content strong{display:block!important;color:#1f2933!important;font-size:1rem!important;margin:0 0 6px!important}',
    '.sls-more-info-popup-content a{display:inline-block!important;margin-top:8px!important;color:#5b7f3a!important;text-decoration:underline!important}',
    '.sls-more-info-popup .sls-close{color:#1f2933!important;opacity:.6}',
    '.sls-more-info-popup::after{border-bottom-color:#fff!important}',
    '.sls-more-info-popup::before{border-bottom-color:#87af59!important;left:18px!important}'
  ].join('\n');

  function injectCSS() {
    if (document.getElementById('nfp-seal-css')) return;
    var s = document.createElement('style');
    s.id = 'nfp-seal-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function relinks() {
    var sel = 'a[href*="sealsubscriptions.com/articles/how-subscriptions-work"]';
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (a) {
      a.setAttribute('href', PAGE);
      a.setAttribute('target', '_self');
      a.removeAttribute('rel');
    });
  }

  function move() {
    var w = document.querySelector('.sealsubs-target-element');
    if (!w || w.getAttribute('data-nfp-moved')) return !!w;
    var pay = document.querySelector('.payment-buttons');
    var atcRow = pay ? pay.closest('.large-row') : null;
    if (atcRow && atcRow.parentNode) {
      atcRow.parentNode.insertBefore(w, atcRow);
      w.setAttribute('data-nfp-moved', '1');
    }
    return !!w;
  }

  function apply() { move(); relinks(); }

  function tick(n) {
    var found = document.querySelector('.sealsubs-target-element');
    apply();
    if (found || n <= 0) return;
    setTimeout(function () { tick(n - 1); }, 300);
  }

  function start() {
    injectCSS();
    tick(40);
    try {
      var mo = new MutationObserver(function () { apply(); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
